var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9991 5.70998C22.0485 4.27864 21.7355 2.858 21.0891 1.57998C20.6505 1.05558 20.0418 0.701694 19.3691 0.579984C16.5866 0.327509 13.7926 0.224028 10.9991 0.269984C8.2157 0.221942 5.43176 0.322084 2.65905 0.569984C2.11087 0.669701 1.60357 0.926826 1.19905 1.30998C0.29905 2.13998 0.19905 3.55998 0.0990503 4.75998C-0.0460376 6.91755 -0.0460376 9.08242 0.0990503 11.24C0.12798 11.9154 0.228544 12.5858 0.39905 13.24C0.519625 13.745 0.763573 14.2123 1.10905 14.6C1.51632 15.0034 2.03543 15.2752 2.59905 15.38C4.75497 15.6461 6.92727 15.7564 9.09905 15.71C12.5991 15.76 15.669 15.71 19.299 15.43C19.8765 15.3316 20.4102 15.0595 20.8291 14.65C21.109 14.3699 21.3181 14.0271 21.4391 13.65C21.7967 12.5526 21.9723 11.4041 21.959 10.25C21.9991 9.68998 21.9991 6.30998 21.9991 5.70998ZM8.73905 10.85V4.65998L14.659 7.76998C12.9991 8.68998 10.809 9.72998 8.73905 10.85Z",
    fill: "#454551"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeImg);
export default __webpack_public_path__ + "static/media/youtube-img.28c6efbfc82ac3173ad8ebf9867e82e2.svg";
export { ForwardRef as ReactComponent };